import React, { type FC } from 'react';
import { Navigate, useLocation } from 'react-router';

const PrivateRoute: FC<React.PropsWithChildren> = ({ children }) => {
    const location = useLocation();
    const token = localStorage.getItem('token');

    if (!token) {
        return (
            <Navigate
                to={{ pathname: '/login' }}
                state={{ from: location }}
            />
        );
    }

    return <>{children}</>;
};

export default PrivateRoute;
